export enum OptForPsrDataTest {
    PSR_TITLE = "PSR_TITLE", 
    YES_BTN = "YES_BTN",
    NO_BTN = "NO_BTN",
    CONTINUE_OR_SUBMIT_BUTTON = "CONTINUE_OR_SUBMIT_BUTTON",
    IMAGE_CUSTOMER = "IMAGE_CUSTOMER",
}
